import React, { useState } from "react";
import AnalyticsStatCard from "../../components-v2/profile-menu/analytics/AnalyticsStatCard";
import AnalyticsDailyChart from "../../components-v2/profile-menu/analytics/AnalyticsDailyChart";
import AnalyticsFeaturesChart from "../../components-v2/profile-menu/analytics/AnalyticsFeaturesChart";
import AnalyticsPerformanceMetrics from "../../components-v2/profile-menu/analytics/AnalyticsPerformanceMetrics";
import AnalyticsLoginHistory from "../../components-v2/profile-menu/analytics/AnalyticsLoginHistory";
import {
  LoginIcon,
  EyeIcon,
  CursorIcon,
  ClockIcon,
  DownloadIcon,
  ChevronDownIcon,
} from "../../components-v2/profile-menu/analytics/AnalyticsIcons";
import "../../styles-v2/profile-menu/v2-analytics-page.css";

const PERIOD_OPTIONS = ["Last 7 days", "Last 30 days", "Last 90 days", "This year"];

const AnalyticsPage = () => {
  const [period, setPeriod] = useState("Last 30 days");
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false);

  return (
    <div className="v2-analytics-pg">
      {/* Header */}
      <div className="v2-analytics-pg__header">
        <div className="v2-analytics-pg__header-text">
          <h1 className="v2-analytics-pg__title">Analytics</h1>
          <p className="v2-analytics-pg__subtitle">
            Track your personal performance and activity metrics
          </p>
        </div>
        <div className="v2-analytics-pg__header-actions">
          <div className="v2-analytics-pg__period-wrapper">
            <button
              className="v2-analytics-pg__period-btn"
              onClick={() => setShowPeriodDropdown((prev) => !prev)}
            >
              <span>{period}</span>
              <ChevronDownIcon size={16} />
            </button>
            {showPeriodDropdown && (
              <div className="v2-analytics-pg__period-dropdown">
                {PERIOD_OPTIONS.map((opt) => (
                  <button
                    key={opt}
                    className={`v2-analytics-pg__period-option${opt === period ? " v2-analytics-pg__period-option--active" : ""}`}
                    onClick={() => {
                      setPeriod(opt);
                      setShowPeriodDropdown(false);
                    }}
                  >
                    {opt}
                  </button>
                ))}
              </div>
            )}
          </div>
          <button className="v2-analytics-pg__export-btn">
            <DownloadIcon size={16} />
            <span>Export Data</span>
          </button>
        </div>
      </div>

      {/* Stat Cards */}
      <div className="v2-analytics-pg__stats">
        <AnalyticsStatCard
          label="Total Logins"
          value="156"
          icon={<LoginIcon size={20} color="#eb1414" />}
          iconBg="#fef2f2"
          trend="+12% from last month"
        />
        <AnalyticsStatCard
          label="Pages Visited"
          value="1,234"
          icon={<EyeIcon size={20} color="#3b82f6" />}
          iconBg="#eff6ff"
          trend="+8% from last month"
        />
        <AnalyticsStatCard
          label="Actions Taken"
          value="456"
          icon={<CursorIcon size={20} color="#8b5cf6" />}
          iconBg="#f5f3ff"
          trend="+15% from last month"
        />
        <AnalyticsStatCard
          label="Avg. Session Time"
          value="24m"
          icon={<ClockIcon size={20} color="#f59e0b" />}
          iconBg="#fffbeb"
          trend="+5% from last month"
        />
      </div>

      {/* Daily Activity Chart */}
      <AnalyticsDailyChart />

      {/* Features & Performance Grid */}
      <div className="v2-analytics-pg__grid-2col">
        <AnalyticsFeaturesChart />
        <AnalyticsPerformanceMetrics />
      </div>

      {/* Login History */}
      <AnalyticsLoginHistory />
    </div>
  );
};

export default AnalyticsPage;
